/*
 * Backend local de l'aperçu privé.
 * Toutes les données restent dans localStorage : aucun paiement, SMS, email,
 * document ou relevé GPS n'est transmis à un service externe.
 */
const USER_KEY = "mml_demo_user";
const MISSIONS_KEY = "mml_demo_missions_v4";
const CANDIDATURES_KEY = "mml_demo_candidatures_v1";
const MESSAGES_KEY = "mml_demo_messages_v1";
const PROFILES_KEY = "mml_demo_profiles_v1";
const DRIVERS_KEY = "mml_demo_drivers_v1";
const DOCUMENTS_KEY = "mml_demo_documents_v1";
const DISPUTES_KEY = "mml_demo_disputes_v1";
const NOTIFICATIONS_KEY = "mml_demo_notifications_v1";
const PAYMENTS_KEY = "mml_demo_payments_v1";
const RATINGS_KEY = "mml_demo_ratings_v1";

const DEMO_KEYS = [
  USER_KEY, MISSIONS_KEY, CANDIDATURES_KEY, MESSAGES_KEY, PROFILES_KEY,
  DRIVERS_KEY, DOCUMENTS_KEY, DISPUTES_KEY, NOTIFICATIONS_KEY,
  PAYMENTS_KEY, RATINGS_KEY,
];

const users = {
  shipper: {
    id: "demo-shipper", name: "Camille Expéditeur", email: "expediteur@demo.mml",
    role: "shipper", phone: "0612345678", phone_verified: true,
    company_type: "individual", kyc_status: "not_required", marketing_consent: false,
    created_at: "2026-01-10T10:00:00Z",
  },
  transporter: {
    id: "demo-carrier", name: "Alex Transport", email: "transporteur@demo.mml",
    role: "transporter", phone: "0677889900", phone_verified: true,
    company_type: "company", company_name: "Transport Démo SAS",
    siret: "12345678901234", kyc_status: "validated", stripe_payouts_enabled: true,
    created_at: "2025-11-20T09:00:00Z",
  },
  admin: {
    id: "demo-admin", name: "Équipe conformité MML", email: "admin@demo.mml",
    role: "admin", phone_verified: true, kyc_status: "not_required",
    created_at: "2025-10-01T09:00:00Z",
  },
};

const profileSeed = {
  "demo-carrier": {
    user_id: "demo-carrier", vehicle_type: "van", vehicle_plate: "AB-123-CD",
    vehicle_brand: "Renault Master", vehicle_ptac_kg: 3500,
    max_weight_kg: 1200, max_volume_m3: 15, base_city: "Toulouse",
    base_postal_code: "31000", base_lat: 43.6045, base_lng: 1.444,
    radius_km: 700, bio: "Transport régional et national, marchandises générales.",
    contact_phone: "0677889900", search_active: true,
  },
  "demo-carrier-2": {
    user_id: "demo-carrier-2", vehicle_type: "van", vehicle_brand: "Iveco Daily",
    max_weight_kg: 1500, max_volume_m3: 17, base_city: "Montauban",
    base_postal_code: "82000", radius_km: 500,
    bio: "Entreprise française vérifiée.",
  },
};

const seedMissions = [
  {
    id: "mml-demo-001", shipper_id: "demo-shipper", shipper_name: "Camille Expéditeur",
    title: "3 palettes de fournitures", description: "Palettes filmées, prêtes au chargement par l'expéditeur.",
    pickup_address: "1 place du Capitole, 31000 Toulouse", pickup_lat: 43.6045, pickup_lng: 1.444,
    delivery_address: "20 quai Augagneur, 69003 Lyon", delivery_lat: 45.7608, delivery_lng: 4.8422,
    pickup_date: "2026-10-06T10:00", cargo_weight_kg: 780, cargo_volume_m3: 4.5,
    declared_value_eur: 2400, estimated_tolls_eur: 36, vehicle_type: "van", transport_mode: "dedicated",
    distance_km: 538, pricing_zone: "countryside", price: 975, status: "open", payment_status: "unpaid",
    platform_commission: 146.25, transporter_amount: 828.75, commission_rate: 0.15,
    candidatures_count: 2, contact_phone: "0612345678", created_at: "2026-09-13T09:30:00Z",
  },
  {
    id: "mml-demo-002", shipper_id: "demo-shipper", shipper_name: "Camille Expéditeur",
    title: "Mobilier professionnel emballé", description: "Mobilier démonté et protégé. Déchargement prévu par le destinataire.",
    pickup_address: "12 rue Alsace-Lorraine, 31000 Toulouse", pickup_lat: 43.606, pickup_lng: 1.446,
    delivery_address: "5 rue de la République, 34000 Montpellier", delivery_lat: 43.6108, delivery_lng: 3.8767,
    pickup_date: "2026-09-10T14:30", cargo_weight_kg: 420, cargo_volume_m3: 5,
    declared_value_eur: 1800, estimated_tolls_eur: 18, vehicle_type: "van", transport_mode: "dedicated",
    distance_km: 244, pricing_zone: "mixed", price: 520, status: "delivered", payment_status: "released",
    platform_commission: 78, transporter_amount: 442, commission_rate: 0.15,
    transporter_id: "demo-carrier", transporter_name: "Alex Transport",
    transporter: { id: "demo-carrier", name: "Alex Transport", company_name: "Transport Démo SAS", phone: "0677889900", kyc_status: "validated" },
    assigned_driver_id: "demo-carrier", assigned_driver_name: "Alex Transport",
    assigned_vehicle_plate: "AB-123-CD", assigned_vehicle_type: "van",
    assignment_confirmed_at: "2026-09-10T13:00:00Z", delivered_at: "2026-09-10T16:20:00Z",
    shipper_confirmed: true, shipper_confirmed_at: "2026-09-10T16:35:00Z",
    proof_signed_name: "Alex Transport", shipper_signed_name: "Camille Expéditeur",
    contact_phone: "0612345678", created_at: "2026-09-06T11:00:00Z",
  },
  {
    id: "mml-demo-live", shipper_id: "demo-shipper", shipper_name: "Camille Expéditeur",
    title: "Suivi GPS — mission en cours", description: "Deux palettes emballées. Mission de démonstration pour tester la carte en direct.",
    pickup_address: "1 place du Capitole, 31000 Toulouse", pickup_lat: 43.6045, pickup_lng: 1.444,
    delivery_address: "2 place Nationale, 82000 Montauban", delivery_lat: 44.0176, delivery_lng: 1.354,
    pickup_date: "2026-10-05T15:00", cargo_weight_kg: 320, cargo_volume_m3: 2.8,
    declared_value_eur: 1200, estimated_tolls_eur: 0, vehicle_type: "van", transport_mode: "dedicated",
    distance_km: 55, pricing_zone: "mixed", price: 210, status: "en_route", payment_status: "paid",
    platform_commission: 31.5, transporter_amount: 178.5, commission_rate: 0.15,
    transporter_id: "demo-carrier", transporter_name: "Alex Transport",
    transporter: { id: "demo-carrier", name: "Alex Transport", company_name: "Transport Démo SAS", phone: "0677889900", kyc_status: "validated" },
    assigned_driver_id: "demo-carrier", assigned_driver_name: "Alex Transport",
    assigned_vehicle_plate: "AB-123-CD", assigned_vehicle_type: "van",
    assignment_confirmed_at: "2026-10-05T14:30:00Z", tracking_active: false,
    contact_phone: "0612345678", created_at: "2026-10-01T08:00:00Z",
  },
];

const seedCandidates = {
  "mml-demo-001": [
    { transporter_id: "demo-carrier", transporter_name: "Alex Transport", company_name: "Transport Démo SAS", transporter_rating: { average: 4.9, count: 42 }, transporter_delivered: 57, response_time_minutes: 7, seconds_left: 3300, status: "active", vehicle_type: "van", bio: "Transport régional et national, marchandises générales." },
    { transporter_id: "demo-carrier-2", transporter_name: "Sam Logistique", company_name: "SL Route", transporter_rating: { average: 4.7, count: 18 }, transporter_delivered: 24, response_time_minutes: 11, seconds_left: 2940, status: "active", vehicle_type: "van", bio: "Entreprise française vérifiée." },
  ],
};

const tinyDocument = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPSc2NDAnIGhlaWdodD0nNDAwJz48cmVjdCB3aWR0aD0nNjQwJyBoZWlnaHQ9JzQwMCcgZmlsbD0nI2Y1ZjVmNCcvPjx0ZXh0IHg9JzMyMCcgeT0nMjAwJyB0ZXh0LWFuY2hvcj0nbWlkZGxlJyBmaWxsPScjMUY0MDMyJyBmb250LXNpemU9JzI0Jz5Eb2N1bWVudCBkZSBkw6ltb25zdHJhdGlvbjwvdGV4dD48L3N2Zz4=";
const requiredDocs = ["vehicle_registration", "vehicle_insurance", "rc_pro", "cargo_insurance", "id_card", "driving_license", "selfie", "vehicle_photo", "kbis", "transport_license"];
const seedDocuments = requiredDocs.map((docType, index) => ({
  id: `demo-doc-${index + 1}`, user_id: "demo-carrier", doc_type: docType,
  status: "validated", license_category: docType === "driving_license" ? "B" : null,
  file_name: `${docType}.svg`, file_size: 512, file_hash: `demo-sha256-${docType}`,
  file_data: tinyDocument, uploaded_at: "2026-09-01T10:00:00Z",
  expires_at: ["driving_license", "vehicle_insurance", "cargo_insurance"].includes(docType) ? "2027-09-01" : null,
}));

const seedNotifications = [
  { id: "n1", type: "mission_accepted", mission_id: "mml-demo-001", text: "Deux transporteurs ont candidaté à la mission Toulouse–Lyon.", read: false, created_at: "2026-09-13T10:05:00Z" },
];

function clone(value) { return value == null ? value : JSON.parse(JSON.stringify(value)); }
function read(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : clone(fallback);
  } catch { return clone(fallback); }
}
function write(key, value) { localStorage.setItem(key, JSON.stringify(value)); }
function getUser() { return read(USER_KEY, null); }
function setUser(user) { if (user) write(USER_KEY, user); else localStorage.removeItem(USER_KEY); }
function getMissions() { return read(MISSIONS_KEY, seedMissions); }
function saveMissions(items) { write(MISSIONS_KEY, items); }
function getCandidatures() { return read(CANDIDATURES_KEY, seedCandidates); }
function getMessages() { return read(MESSAGES_KEY, {}); }
function getProfiles() { return read(PROFILES_KEY, profileSeed); }
function getDrivers() { return read(DRIVERS_KEY, []); }
function getDocuments() { return read(DOCUMENTS_KEY, seedDocuments); }
function getDisputes() { return read(DISPUTES_KEY, []); }
function getNotifications() { return read(NOTIFICATIONS_KEY, seedNotifications); }
function getRatings() { return read(RATINGS_KEY, [
  { id: "rating-demo-1", mission_id: "mml-demo-002", from_user_id: "demo-shipper", to_user_id: "demo-carrier", score: 5, comment: "Ponctuel et soigneux.", created_at: "2026-09-10T17:00:00Z" },
]); }

function ok(config, data, status = 200) { return Promise.resolve({ data, status, statusText: "OK", headers: {}, config }); }
function fail(config, status, detail) {
  const error = new Error(detail);
  error.config = config;
  error.response = { data: { detail }, status, statusText: "Erreur", headers: {}, config };
  return Promise.reject(error);
}
function bodyOf(config) {
  if (!config.data) return {};
  if (typeof config.data === "string") { try { return JSON.parse(config.data); } catch { return {}; } }
  return config.data;
}
function queryOf(raw) {
  const q = raw.includes("?") ? raw.slice(raw.indexOf("?") + 1) : "";
  return new URLSearchParams(q);
}
function findUser(id) {
  if (id === "demo-carrier-2") return { id, name: "Sam Logistique", company_name: "SL Route", role: "transporter", kyc_status: "validated", created_at: "2026-02-02T10:00:00Z" };
  return Object.values(users).find((u) => u.id === id) || (getUser()?.id === id ? getUser() : null);
}
function transporterSummary(id) {
  const u = findUser(id);
  if (!u) return null;
  return { id: u.id, name: u.name, company_name: u.company_name, phone: u.phone, kyc_status: u.kyc_status };
}
function updateMission(id, updater) {
  let updated = null;
  const items = getMissions().map((m) => {
    if (m.id !== id) return m;
    updated = typeof updater === "function" ? updater(m) : { ...m, ...updater };
    return updated;
  });
  if (updated) saveMissions(items);
  return updated;
}
function visibleMission(mission, user) {
  const { tracking_session_id, ...visible } = mission;
  const candidatures = getCandidatures()[mission.id] || [];
  const mine = candidatures.find((c) => c.transporter_id === user?.id);
  if (mine) visible.my_candidature = { status: mine.status, seconds_left: mine.seconds_left };
  if (visible.transporter_id && !visible.transporter) visible.transporter = transporterSummary(visible.transporter_id);
  return visible;
}
function analyticsFor(userId) {
  const missions = getMissions().filter((m) => m.transporter_id === userId);
  const byStatus = { open: 0, accepted: 0, loaded: 0, en_route: 0, delivered: 0, cancelled: 0 };
  missions.forEach((m) => { byStatus[m.status] = (byStatus[m.status] || 0) + 1; });
  const delivered = missions.filter((m) => m.status === "delivered");
  const released = delivered.filter((m) => ["released", "partial_refunded", "partially_refunded"].includes(m.payment_status));
  const monthLabels = ["Oct", "Nov", "Déc", "Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Jui", "Aoû", "Sep"];
  const monthly = monthLabels.map((month, index) => ({ month, year: index < 3 ? 2025 : 2026, earnings: index === 11 ? released.reduce((sum, m) => sum + Number(m.transporter_amount || 0), 0) : 0, missions: index === 11 ? released.length : 0, distance: index === 11 ? released.reduce((sum, m) => sum + Number(m.distance_km || 0), 0) : 0 }));
  const ratings = getRatings().filter((r) => r.to_user_id === userId);
  const distribution = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
  ratings.forEach((r) => { distribution[r.score] = (distribution[r.score] || 0) + 1; });
  return {
    monthly, current_month_revenue: monthly[11].earnings, previous_month_revenue: 0,
    delta_pct: 0, by_status: byStatus,
    total_distance_km: delivered.reduce((sum, m) => sum + Number(m.distance_km || 0), 0),
    delivered_count: delivered.length, cancelled_count: byStatus.cancelled,
    completion_rate: delivered.length + byStatus.cancelled ? Math.round(delivered.length / (delivered.length + byStatus.cancelled) * 1000) / 10 : 0,
    rating_average: ratings.length ? ratings.reduce((sum, r) => sum + r.score, 0) / ratings.length : 0,
    rating_count: ratings.length, rating_distribution: distribution,
  };
}

export function resetDemoState() { DEMO_KEYS.forEach((key) => localStorage.removeItem(key)); }

export async function demoAdapter(config) {
  await new Promise((resolve) => setTimeout(resolve, 80));
  const method = (config.method || "get").toLowerCase();
  const raw = String(config.url || "");
  const path = raw.replace(/^\/api/, "").split("?")[0];
  const query = queryOf(raw);
  const body = bodyOf(config);
  let user = getUser();

  // Routes publiques : elles fonctionnent avant la vérification de session.
  if (path === "/auth/login" && method === "post") {
    const email = String(body.email || "").toLowerCase();
    const role = email.includes("admin") ? "admin" : email.includes("transporteur") ? "transporter" : "shipper";
    user = clone(users[role]); setUser(user);
    return ok(config, { user });
  }
  if (path === "/auth/register" && method === "post") {
    const role = body.role === "transporter" ? "transporter" : "shipper";
    user = { ...clone(users[role]), ...body, id: `demo-${role}-${Date.now()}`, phone_verified: false, kyc_status: role === "transporter" ? "incomplete" : "not_required", created_at: new Date().toISOString() };
    setUser(user);
    return ok(config, { user });
  }
  if (path === "/auth/forgot-password" && method === "post") {
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    return ok(config, { message: "Mode test : aucun email n'a été envoyé.", email_sent: false, dev_note: "Utilisez ce lien local pour tester le formulaire.", dev_reset_link: `${origin}/reset-password?token=demo-reset-token` });
  }
  if (path === "/auth/reset-password" && method === "post") return body.token ? ok(config, { ok: true }) : fail(config, 400, "Jeton manquant");
  if (path === "/auth/resend-reset" && method === "post") return ok(config, { email_sent: false, message: "Nouveau lien de démonstration créé.", dev_reset_link: `/reset-password?token=demo-reset-token-2` });
  if (path === "/contact" && method === "post") return ok(config, { message: "Message enregistré dans la démonstration — aucun envoi réel." });
  const publicMatch = path.match(/^\/users\/([^/]+)\/public$/);
  if (publicMatch && method === "get") {
    const target = findUser(publicMatch[1]);
    if (!target) return fail(config, 404, "Utilisateur introuvable");
    const profile = getProfiles()[target.id] || null;
    const ratings = getRatings().filter((r) => r.to_user_id === target.id);
    return ok(config, {
      user: { id: target.id, name: target.name, company_name: target.company_name, kyc_status: target.kyc_status, created_at: target.created_at },
      profile: profile ? { vehicle_type: profile.vehicle_type, vehicle_brand: profile.vehicle_brand, base_city: profile.base_city, base_postal_code: profile.base_postal_code, radius_km: profile.radius_km, max_weight_kg: profile.max_weight_kg, max_volume_m3: profile.max_volume_m3, bio: profile.bio } : null,
      ratings: { average: ratings.length ? ratings.reduce((s, r) => s + r.score, 0) / ratings.length : 0, count: ratings.length, items: ratings },
      completed_missions: getMissions().filter((m) => m.transporter_id === target.id && m.status === "delivered").length,
      published_missions: getMissions().filter((m) => m.shipper_id === target.id).length,
      delivered_as_shipper: getMissions().filter((m) => m.shipper_id === target.id && m.status === "delivered").length,
    });
  }
  if (path.startsWith("/referral/validate/") && method === "get") return fail(config, 404, "Le parrainage n'est pas disponible au lancement");

  if (path === "/auth/logout" && method === "post") { setUser(null); return ok(config, { ok: true }); }
  if (path === "/auth/me" && method === "get") return user ? ok(config, user) : fail(config, 401, "Non authentifié");
  if (!user) return fail(config, 401, "Connectez-vous pour utiliser l'aperçu.");

  if (path === "/auth/me" && method === "patch") {
    user = { ...user, ...body }; setUser(user); return ok(config, user);
  }
  if (path === "/auth/otp/send" && method === "post") return ok(config, { ok: true, phone_masked: String(body.phone || user.phone || "").replace(/.(?=.{4})/g, "•"), demo_code: "123456" });
  if (path === "/auth/otp/verify" && method === "post") {
    if (!/^\d{4,8}$/.test(String(body.code || ""))) return fail(config, 400, "Code invalide");
    user = { ...user, phone: body.phone || user.phone, phone_verified: true }; setUser(user);
    return ok(config, { ok: true, phone_verified: true });
  }

  if (path === "/users/me/export" && method === "get") return ok(config, { exported_at: new Date().toISOString(), user, missions: getMissions().filter((m) => m.shipper_id === user.id || m.transporter_id === user.id), documents: getDocuments().filter((d) => d.user_id === user.id).map(({ file_data, ...d }) => d), messages: Object.values(getMessages()).flat().filter((m) => m.sender_id === user.id) });
  if (path === "/users/me/consents" && method === "patch") {
    const next = { ...user };
    if ("marketing_consent" in body) { next.marketing_consent = Boolean(body.marketing_consent); next.marketing_consent_at = body.marketing_consent ? new Date().toISOString() : null; }
    if ("ai_biometric_consent" in body) next.ai_biometric_consent_at = body.ai_biometric_consent ? new Date().toISOString() : null;
    setUser(next); user = next;
    return ok(config, { ok: true, marketing_consent: Boolean(user.marketing_consent), marketing_consent_at: user.marketing_consent_at || null, ai_biometric_consent_at: user.ai_biometric_consent_at || null, terms_accepted_at: user.terms_accepted_at || null });
  }
  if (path === "/users/me" && method === "delete") {
    setUser(null);
    return ok(config, { ok: true, message: "Compte de démonstration supprimé localement. Les données de départ reviendront après réinitialisation.", anonymized_id: user.id });
  }

  if (path === "/missions" && method === "get") {
    const items = getMissions();
    if (query.get("view") === "transporter") {
      let available = items.filter((m) => m.status === "open" && m.shipper_id !== user.id);
      const q = (query.get("q") || "").toLowerCase();
      const city = (query.get("city") || "").toLowerCase();
      const vehicle = query.get("vehicle_type");
      const minPrice = Number(query.get("price_min") || 0);
      const maxPrice = Number(query.get("price_max") || Infinity);
      if (q) available = available.filter((m) => [m.title, m.description, m.pickup_address, m.delivery_address].some((v) => String(v || "").toLowerCase().includes(q)));
      if (city) available = available.filter((m) => `${m.pickup_address} ${m.delivery_address}`.toLowerCase().includes(city));
      if (vehicle) available = available.filter((m) => m.vehicle_type === vehicle);
      available = available.filter((m) => Number(m.price) >= minPrice && Number(m.price) <= maxPrice);
      const cands = getCandidatures();
      available = available.map((m, index) => {
        const mine = (cands[m.id] || []).find((c) => c.transporter_id === user.id);
        return { ...m, distance_from_you_km: 2.4 + index * 8.6, shipper_rating: { average: 4.8, count: 12 }, ...(mine ? { my_candidature: { status: mine.status, seconds_left: mine.seconds_left } } : {}) };
      });
      const sort = query.get("sort");
      if (sort === "price_desc") available.sort((a, b) => b.price - a.price);
      if (sort === "price_asc") available.sort((a, b) => a.price - b.price);
      const profile = getProfiles()[user.id] || null;
      return ok(config, {
        missions: available, my_missions: items.filter((m) => m.transporter_id === user.id),
        kyc_status: user.kyc_status || "incomplete", blocked: user.kyc_status !== "validated",
        search_active: Boolean(profile?.search_active), nearby_email_enabled: user.nearby_email_enabled !== false,
        sms_alerts_enabled: Boolean(user.sms_alerts_enabled),
        pagination: { page: 1, page_size: 20, total: available.length, total_pages: available.length ? 1 : 0 },
      });
    }
    return ok(config, items.filter((m) => m.shipper_id === user.id));
  }
  if (path === "/missions" && method === "post") {
    const price = Number(body.price);
    const item = { ...body, id: `mml-demo-${Date.now()}`, shipper_id: user.id, shipper_name: user.name, status: "open", payment_status: "unpaid", transport_mode: "dedicated", commission_rate: 0.15, platform_commission: Math.round(price * 15) / 100, transporter_amount: Math.round(price * 85) / 100, candidatures_count: 0, created_at: new Date().toISOString() };
    saveMissions([item, ...getMissions()]);
    return ok(config, item, 201);
  }
  const missionMatch = path.match(/^\/missions\/([^/]+)$/);
  if (missionMatch && method === "get") {
    const mission = getMissions().find((m) => m.id === missionMatch[1]);
    return mission ? ok(config, visibleMission(mission, user)) : fail(config, 404, "Mission introuvable");
  }
  if (missionMatch && method === "patch") {
    const price = body.price == null ? null : Number(body.price);
    const patch = price == null ? body : { ...body, price, platform_commission: Math.round(price * 15) / 100, transporter_amount: Math.round(price * 85) / 100 };
    const updated = updateMission(missionMatch[1], patch);
    return updated ? ok(config, updated) : fail(config, 404, "Mission introuvable");
  }
  if (missionMatch && method === "delete") {
    const before = getMissions();
    if (!before.some((m) => m.id === missionMatch[1])) return fail(config, 404, "Mission introuvable");
    saveMissions(before.filter((m) => m.id !== missionMatch[1]));
    return ok(config, { ok: true, deleted: missionMatch[1] });
  }

  const candidatureMatch = path.match(/^\/missions\/([^/]+)\/candidatures$/);
  if (candidatureMatch && method === "get") {
    const list = (getCandidatures()[candidatureMatch[1]] || []).filter((c) => c.status === "active");
    return ok(config, { mission_status: getMissions().find((m) => m.id === candidatureMatch[1])?.status, candidatures: list, count: list.length });
  }
  const messagesMatch = path.match(/^\/missions\/([^/]+)\/messages$/);
  if (messagesMatch && method === "get") return ok(config, getMessages()[messagesMatch[1]] || []);
  if (messagesMatch && method === "post") {
    const all = getMessages();
    const message = { id: `msg-${Date.now()}`, mission_id: messagesMatch[1], sender_id: user.id, sender_name: user.name, text: body.text, created_at: new Date().toISOString() };
    all[messagesMatch[1]] = [...(all[messagesMatch[1]] || []), message]; write(MESSAGES_KEY, all);
    return ok(config, message, 201);
  }

  const actionMatch = path.match(/^\/missions\/([^/]+)\/(apply|withdraw|select|status|assignment|cancel|confirm-receipt|report-absence|rate)$/);
  if (actionMatch && method === "post") {
    const [, id, action] = actionMatch;
    const mission = getMissions().find((m) => m.id === id);
    if (!mission) return fail(config, 404, "Mission introuvable");
    if (action === "apply") {
      const all = getCandidatures();
      const existing = (all[id] || []).filter((c) => c.transporter_id !== user.id);
      const cand = { transporter_id: user.id, transporter_name: user.name, company_name: user.company_name, transporter_rating: { average: 4.9, count: 42 }, transporter_delivered: 57, response_time_minutes: 1, seconds_left: 3600, status: "active", vehicle_type: getProfiles()[user.id]?.vehicle_type || "van" };
      all[id] = [...existing, cand]; write(CANDIDATURES_KEY, all);
      updateMission(id, { candidatures_count: all[id].filter((c) => c.status === "active").length });
      return ok(config, { ok: true, candidature_id: `demo-cand-${Date.now()}`, validity_minutes: 60, expires_at: new Date(Date.now() + 3600000).toISOString() });
    }
    if (action === "withdraw") {
      const all = getCandidatures();
      all[id] = (all[id] || []).map((c) => c.transporter_id === user.id ? { ...c, status: "withdrawn" } : c); write(CANDIDATURES_KEY, all);
      return ok(config, { ok: true });
    }
    if (action === "select") {
      const all = getCandidatures();
      const selected = (all[id] || []).find((c) => c.transporter_id === body.transporter_id && c.status === "active");
      if (!selected) return fail(config, 404, "Candidature introuvable ou retirée");
      all[id] = (all[id] || []).map((c) => ({ ...c, status: c.transporter_id === body.transporter_id ? "selected" : "expired" })); write(CANDIDATURES_KEY, all);
      const selectedAt = new Date().toISOString();
      return ok(config, updateMission(id, { status: "accepted", transporter_id: selected.transporter_id, transporter_name: selected.transporter_name, transporter: transporterSummary(selected.transporter_id), payment_status: "unpaid", selected_at: selectedAt, contract_snapshot_version: 1 }));
    }
    if (action === "assignment") return ok(config, updateMission(id, { assigned_driver_id: body.driver_id, assigned_driver_name: body.driver_name, assigned_vehicle_plate: body.vehicle_plate, assigned_vehicle_type: body.vehicle_type, assignment_confirmed_at: new Date().toISOString() }));
    if (action === "status") {
      const now = new Date().toISOString();
      const patch = { ...body, status: body.status, ...(body.status === "loaded" ? { loaded_at: now } : {}), ...(body.status === "en_route" ? { en_route_at: now } : {}), ...(body.status === "delivered" ? { delivered_at: now, tracking_active: false, tracking_stopped_at: now, tracking_stop_reason: "mission_delivered" } : {}) };
      delete patch.tracking_session_id;
      return ok(config, updateMission(id, (m) => { const next = { ...m, ...patch }; if (body.status === "delivered") { delete next.tracking_session_id; delete next.transporter_position; } return next; }));
    }
    if (action === "confirm-receipt") return ok(config, updateMission(id, { shipper_confirmed: true, shipper_signature: body.signature, shipper_signed_name: body.signed_name, shipper_confirmed_at: new Date().toISOString(), payment_status: "released", released_at: new Date().toISOString() }));
    if (action === "cancel") return ok(config, updateMission(id, { status: "cancelled", cancellation_reason: body.reason, cancelled_at: new Date().toISOString(), payment_status: ["paid", "pending"].includes(mission.payment_status) ? "refunded" : mission.payment_status }));
    if (action === "report-absence") {
      const wasPaid = ["paid", "pending"].includes(mission.payment_status);
      return ok(config, { mission: updateMission(id, (m) => { const next = { ...m, status: "open", payment_status: wasPaid ? "refunded" : "unpaid", absence_reported_at: new Date().toISOString() }; ["transporter_id", "transporter_name", "transporter", "assigned_driver_id", "assigned_driver_name", "assigned_vehicle_plate", "assigned_vehicle_type", "assignment_confirmed_at"].forEach((key) => delete next[key]); return next; }), refund: { ok: true, simulated: true } });
    }
    if (action === "rate") {
      const target = user.id === mission.shipper_id ? mission.transporter_id : mission.shipper_id;
      const ratings = getRatings();
      const rating = { id: `rating-${Date.now()}`, mission_id: id, from_user_id: user.id, to_user_id: target, score: Number(body.score), comment: body.comment || null, created_at: new Date().toISOString() };
      write(RATINGS_KEY, [...ratings.filter((r) => !(r.mission_id === id && r.from_user_id === user.id)), rating]);
      return ok(config, rating, 201);
    }
  }

  const contractMatch = path.match(/^\/missions\/([^/]+)\/contract$/);
  if (contractMatch && method === "get") {
    const mission = getMissions().find((m) => m.id === contractMatch[1]);
    if (!mission) return fail(config, 404, "Mission introuvable");
    return ok(config, { ...mission, version: mission.contract_snapshot_version || 1, status: mission.status === "accepted" && mission.payment_status === "unpaid" ? "pending_payment" : ["paid", "released"].includes(mission.payment_status) ? "formed" : mission.status, selected_at: mission.selected_at || mission.assignment_confirmed_at, formed_at: ["paid", "released"].includes(mission.payment_status) ? (mission.paid_at || mission.assignment_confirmed_at) : null });
  }

  const trackingMatch = path.match(/^\/missions\/([^/]+)\/tracking(?:\/(start|stop))?$/);
  if (trackingMatch) {
    const [, missionId, action] = trackingMatch;
    const selected = getMissions().find((m) => m.id === missionId);
    if (!selected) return fail(config, 404, "Mission introuvable");
    if (method === "post" && action === "start") {
      if (body.consent !== true) return fail(config, 400, "Consentement explicite requis");
      const sessionId = `tracking-${Date.now()}`;
      updateMission(missionId, { tracking_active: true, tracking_session_id: sessionId, tracking_started_at: new Date().toISOString(), tracking_stop_reason: null });
      return ok(config, { ok: true, tracking_active: true, session_id: sessionId, fresh_seconds: 90 });
    }
    if (method === "post" && action === "stop") {
      updateMission(missionId, (m) => { const next = { ...m, tracking_active: false, tracking_stopped_at: new Date().toISOString(), tracking_stop_reason: "driver_stopped" }; delete next.tracking_session_id; delete next.transporter_position; return next; });
      return ok(config, { ok: true, tracking_active: false });
    }
    if (method === "get" && !action) {
      const updatedAt = selected.transporter_position?.updated_at;
      const fresh = Boolean(selected.tracking_active && updatedAt && Date.now() - new Date(updatedAt).getTime() <= 90000);
      return ok(config, { tracking_active: Boolean(selected.tracking_active), tracking_live: fresh, position: fresh ? selected.transporter_position : null, last_seen_at: selected.tracking_last_seen_at || updatedAt || null, started_at: selected.tracking_started_at || null, stopped_at: selected.tracking_stopped_at || null, stop_reason: selected.tracking_stop_reason || null, fresh_seconds: 90 });
    }
  }
  const positionMatch = path.match(/^\/missions\/([^/]+)\/position$/);
  if (positionMatch && method === "post") {
    const missionId = positionMatch[1];
    const selected = getMissions().find((m) => m.id === missionId);
    if (!selected) return fail(config, 404, "Mission introuvable");
    if (!selected.tracking_active || selected.tracking_session_id !== body.session_id) return fail(config, 409, "Session de suivi inactive ou expirée");
    const lat = Number(body.lat); const lng = Number(body.lng);
    if (!Number.isFinite(lat) || lat < -90 || lat > 90 || !Number.isFinite(lng) || lng < -180 || lng > 180) return fail(config, 422, "Coordonnées GPS invalides");
    const now = new Date().toISOString();
    updateMission(missionId, { tracking_last_seen_at: now, transporter_position: { lat, lng, updated_at: now, accuracy_m: body.accuracy_m, speed_mps: body.speed_mps, heading_deg: body.heading_deg } });
    return ok(config, { ok: true, received_at: now });
  }

  const disputeMatch = path.match(/^\/missions\/([^/]+)\/dispute$/);
  if (disputeMatch && method === "get") {
    const dispute = getDisputes().find((d) => d.mission_id === disputeMatch[1]);
    const mission = getMissions().find((m) => m.id === disputeMatch[1]);
    return ok(config, { dispute: dispute || null, can_open: Boolean(!dispute && mission?.status === "delivered") });
  }
  if (disputeMatch && method === "post") {
    const mission = getMissions().find((m) => m.id === disputeMatch[1]);
    if (!mission || mission.status !== "delivered") return fail(config, 400, "Un litige ne peut être ouvert qu'après livraison");
    const now = new Date();
    const dispute = { id: `dispute-${Date.now()}`, mission_id: mission.id, shipper_id: mission.shipper_id, transporter_id: mission.transporter_id, opened_by: user.id, opened_side: user.id === mission.shipper_id ? "shipper" : "transporter", type: body.type, description: body.description, amount_contested: body.amount_contested, status: "open", created_at: now.toISOString(), deadline_admin: new Date(now.getTime() + 7 * 86400000).toISOString(), timeline: [{ action: "opened", by: user.id, side: user.id === mission.shipper_id ? "shipper" : "transporter", message: body.description, photos: body.photos || [], at: now.toISOString() }] };
    write(DISPUTES_KEY, [...getDisputes(), dispute]);
    return ok(config, dispute, 201);
  }
  const disputeRespond = path.match(/^\/disputes\/([^/]+)\/respond$/);
  if (disputeRespond && method === "post") {
    let updated;
    const all = getDisputes().map((d) => {
      if (d.id !== disputeRespond[1]) return d;
      updated = { ...d, status: "responded", timeline: [...(d.timeline || []), { action: "response", by: user.id, side: user.id === d.shipper_id ? "shipper" : "transporter", message: body.message, photos: body.photos || [], at: new Date().toISOString() }] };
      return updated;
    });
    write(DISPUTES_KEY, all);
    return updated ? ok(config, updated) : fail(config, 404, "Litige introuvable");
  }

  const invoicesMatch = path.match(/^\/missions\/([^/]+)\/invoices$/);
  if (invoicesMatch && method === "get") {
    const mission = getMissions().find((m) => m.id === invoicesMatch[1]);
    const available = mission?.status === "delivered" && mission?.payment_status === "released" ? [{ kind: "platform_commission", label: "Facture de commission MML" }, { kind: "transporter_statement", label: "Relevé transporteur" }] : [];
    return ok(config, { available });
  }
  if (/^\/missions\/[^/]+\/invoice\.pdf$/.test(path) && method === "get") return ok(config, "%PDF-1.4\n% MML aperçu privé — document comptable fictif\n%%EOF");

  if (path === "/transporter/profile" && method === "get") return ok(config, getProfiles()[user.id] || null);
  if (path === "/transporter/profile" && method === "put") {
    const profiles = getProfiles();
    profiles[user.id] = { ...body, user_id: user.id };
    write(PROFILES_KEY, profiles);
    return ok(config, profiles[user.id]);
  }
  if (path === "/transporter/vehicle-type" && method === "patch") {
    const profiles = getProfiles();
    profiles[user.id] = { ...(profiles[user.id] || { user_id: user.id }), vehicle_type: body.vehicle_type };
    write(PROFILES_KEY, profiles);
    return ok(config, profiles[user.id]);
  }
  if (["/transporter/search-active", "/transporter/nearby-email", "/transporter/sms-alerts"].includes(path) && method === "patch") {
    if (path === "/transporter/search-active") {
      const profiles = getProfiles();
      profiles[user.id] = { ...(profiles[user.id] || { user_id: user.id }), search_active: Boolean(body.active) };
      write(PROFILES_KEY, profiles);
      return ok(config, { active: Boolean(body.active) });
    }
    const key = path.includes("nearby-email") ? "nearby_email_enabled" : "sms_alerts_enabled";
    user = { ...user, [key]: Boolean(body.enabled) };
    setUser(user);
    return ok(config, { enabled: Boolean(body.enabled), phone_valid: Boolean(user.phone) });
  }
  if (path === "/transporter/earnings" && method === "get") {
    const released = getMissions().filter((m) => m.transporter_id === user.id && m.status === "delivered" && m.payment_status === "released");
    const pending = getMissions().filter((m) => m.transporter_id === user.id && m.payment_status === "paid");
    return ok(config, { total: released.reduce((sum, m) => sum + Number(m.transporter_amount || 0), 0), pending_payout: pending.reduce((sum, m) => sum + Number(m.transporter_amount || 0), 0), missions_count: released.length, missions: released });
  }
  if (path === "/transporter/analytics" && method === "get") return ok(config, analyticsFor(user.id));
  if (path === "/transporter/missions.csv" && method === "get") return ok(config, "ID mission;Titre;Statut;Prix;Net transporteur\n" + getMissions().filter((m) => m.transporter_id === user.id).map((m) => `${m.id};${m.title};${m.status};${m.price};${m.transporter_amount}`).join("\n"));

  if (path === "/transporter/drivers" && method === "get") return ok(config, getDrivers().filter((d) => d.transporter_id === user.id));
  if (path === "/transporter/drivers" && method === "post") {
    const driver = { id: `driver-${Date.now()}`, transporter_id: user.id, name: body.name, phone: body.phone, license_category: body.license_category, status: "pending", created_at: new Date().toISOString() };
    write(DRIVERS_KEY, [...getDrivers(), driver]);
    return ok(config, driver, 201);
  }
  const driverDelete = path.match(/^\/transporter\/drivers\/([^/]+)$/);
  if (driverDelete && method === "delete") {
    write(DRIVERS_KEY, getDrivers().filter((d) => d.id !== driverDelete[1]));
    return ok(config, { ok: true });
  }

  if (path === "/transporter/kyc-status" && method === "get") {
    const documents = getDocuments().filter((d) => d.user_id === user.id);
    return ok(config, { status: user.kyc_status || "incomplete", required: requiredDocs, documents, required_license_category: "B", vehicle_type: getProfiles()[user.id]?.vehicle_type || "van" });
  }
  if (path === "/documents" && method === "post") {
    const documents = getDocuments().filter((d) => !(d.user_id === user.id && d.doc_type === body.doc_type));
    const doc = { ...body, id: `doc-${Date.now()}-${body.doc_type}`, user_id: user.id, status: "pending", uploaded_at: new Date().toISOString(), file_data: tinyDocument, file_data_back: body.file_data_back ? tinyDocument : null };
    write(DOCUMENTS_KEY, [...documents, doc]);
    return ok(config, doc, 201);
  }
  if (path === "/documents" && method === "get") return ok(config, getDocuments().filter((d) => d.user_id === user.id));
  const docExpiry = path.match(/^\/documents\/([^/]+)\/expiry$/);
  if (docExpiry && method === "patch") {
    const all = getDocuments().map((d) => d.user_id === user.id && d.doc_type === docExpiry[1] ? { ...d, expires_at: body.expires_at || null } : d);
    write(DOCUMENTS_KEY, all);
    return ok(config, { ok: true });
  }
  const documentMatch = path.match(/^\/documents\/([^/]+)$/);
  if (documentMatch && method === "get") {
    const doc = getDocuments().find((d) => d.id === documentMatch[1]);
    return doc ? ok(config, doc) : fail(config, 404, "Document introuvable");
  }
  if (documentMatch && method === "delete") {
    write(DOCUMENTS_KEY, getDocuments().filter((d) => d.id !== documentMatch[1]));
    return ok(config, { ok: true });
  }

  if (path === "/stripe/connect/status" && method === "get") return ok(config, { has_account: true, connected: true, payouts_enabled: true, charges_enabled: true, requirements_currently_due: [], demo: true });
  if (["/stripe/connect/onboard", "/stripe/connect/dashboard"].includes(path) && method === "post") return ok(config, { url: `${body.origin_url || window.location.origin}/transporter?stripe_onboard=demo`, demo: true });
  if (path === "/payments/checkout" && method === "post") {
    const mission = getMissions().find((m) => m.id === body.mission_id);
    if (!mission) return fail(config, 404, "Mission introuvable");
    const sessionId = `demo-checkout-${Date.now()}`;
    updateMission(mission.id, { payment_status: "paid", paid_at: new Date().toISOString(), stripe_session_id: sessionId });
    const payments = read(PAYMENTS_KEY, {});
    payments[sessionId] = { mission_id: mission.id, payment_status: "paid", status: "complete" };
    write(PAYMENTS_KEY, payments);
    return ok(config, { url: `${body.origin_url || window.location.origin}/missions/${mission.id}?session_id=${sessionId}&payment=success`, session_id: sessionId, demo: true });
  }
  if (path === "/payments/cancel" && method === "post") {
    updateMission(body.mission_id, (m) => ({ ...m, payment_status: m.payment_status === "pending" ? "unpaid" : m.payment_status }));
    return ok(config, { ok: true });
  }
  const paymentStatus = path.match(/^\/payments\/status\/([^/]+)$/);
  if (paymentStatus && method === "get") return ok(config, read(PAYMENTS_KEY, {})[paymentStatus[1]] || { payment_status: "paid", status: "complete" });

  if (path === "/notifications" && method === "get") return ok(config, getNotifications());
  if (path === "/notifications/read-all" && method === "post") {
    write(NOTIFICATIONS_KEY, getNotifications().map((n) => ({ ...n, read: true })));
    return ok(config, { ok: true });
  }
  const notificationRead = path.match(/^\/notifications\/([^/]+)\/read$/);
  if (notificationRead && method === "post") {
    write(NOTIFICATIONS_KEY, getNotifications().map((n) => n.id === notificationRead[1] ? { ...n, read: true } : n));
    return ok(config, { ok: true });
  }

  if (path === "/admin/stats" && method === "get") return ok(config, { users_total: 4, transporters: 2, transporters_validated: 2, missions_total: getMissions().length, missions_delivered: getMissions().filter((m) => m.status === "delivered").length });
  if (path === "/admin/users" && method === "get") return ok(config, [...Object.values(users), findUser("demo-carrier-2")]);
  if (path === "/admin/documents" && method === "get") return ok(config, getDocuments().map((d) => ({ ...d, user: findUser(d.user_id) })));
  if (path === "/admin/disputes" && method === "get") return ok(config, getDisputes().filter((d) => d.status !== "resolved"));
  if (path === "/admin/review-queue" && method === "get") return ok(config, []);
  if (path === "/admin/drivers" && method === "get") return ok(config, getDrivers());
  const adminDoc = path.match(/^\/admin\/documents\/([^/]+)\/validate$/);
  if (adminDoc && method === "post") {
    const all = getDocuments().map((d) => d.id === adminDoc[1] ? { ...d, status: body.status, rejection_reason: body.reason || null } : d);
    write(DOCUMENTS_KEY, all);
    return ok(config, { ok: true });
  }
  const adminDriver = path.match(/^\/admin\/drivers\/([^/]+)\/status$/);
  if (adminDriver && method === "patch") {
    const all = getDrivers().map((d) => d.id === adminDriver[1] ? { ...d, status: body.status, rejection_reason: body.reason || null } : d);
    write(DRIVERS_KEY, all);
    return ok(config, { ok: true });
  }
  const adminDispute = path.match(/^\/admin\/disputes\/([^/]+)\/resolve$/);
  if (adminDispute && method === "post") {
    let updated;
    const all = getDisputes().map((d) => {
      if (d.id !== adminDispute[1]) return d;
      updated = { ...d, ...body, status: "resolved", resolved_at: new Date().toISOString(), timeline: [...(d.timeline || []), { action: "resolved", by: user.id, side: "admin", message: body.admin_notes || "Décision enregistrée", at: new Date().toISOString() }] };
      return updated;
    });
    write(DISPUTES_KEY, all);
    return updated ? ok(config, updated) : fail(config, 404, "Litige introuvable");
  }

  if (path === "/referral/me" && method === "get") return fail(config, 404, "Le parrainage n'est pas disponible au lancement");
  if (path === "/push/vapid-public-key" && method === "get") return ok(config, { public_key: "" });
  if (path === "/push/radius-grid" && method === "get") return ok(config, { grid: { car: 50, van: 100, truck: 200, heavy_truck: 300 } });
  if (path === "/push/status" && method === "get") return ok(config, { configured: false, subscribed: false, demo: true });
  if (path.startsWith("/push/") && method === "post") return ok(config, { ok: true, demo: true });

  return fail(config, 404, `Route de démonstration non implémentée : ${method.toUpperCase()} ${path}`);
}
